import React, { createContext, useContext, useMemo } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDateFormatPreference } from "@/hooks/use-date-format-preference";
import { DateFormatConfig } from "@/utils/date-format-config";
import { DateFormatPreference } from "@/enums/date-format";

interface DateFormatContextValue {
  preference: DateFormatPreference;
  config: DateFormatConfig;
}

const DateFormatContext = createContext<DateFormatContextValue | null>(null);

export function DateFormatProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { preference, config } = useDateFormatPreference();
  const value = useMemo(() => ({ preference, config }), [preference, config]);

  return (
    <DateFormatContext.Provider value={value}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={config.adapterLocale}
      >
        {children}
      </LocalizationProvider>
    </DateFormatContext.Provider>
  );
}

export function useDateFormatContext(): DateFormatContextValue {
  const ctx = useContext(DateFormatContext);
  if (!ctx) {
    throw new Error("useDateFormatContext must be used within DateFormatProvider");
  }
  return ctx;
}
